export default __webpack_public_path__ + "static/media/chie_horizontal-white_flex.549096df.png";